var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 9.6H7.2V7.2H9.6V5.6H7.2V3.2H5.6V5.6H3.2V7.2H5.6V9.6ZM6.4 13.88C8.02667 12.3867 9.23333 11.03 10.02 9.81C10.8067 8.59 11.2 7.50667 11.2 6.56C11.2 5.10667 10.7367 3.91667 9.81 2.99C8.88333 2.06333 7.74667 1.6 6.4 1.6C5.05333 1.6 3.91667 2.06333 2.99 2.99C2.06333 3.91667 1.6 5.10667 1.6 6.56C1.6 7.50667 1.99333 8.59 2.78 9.81C3.56667 11.03 4.77333 12.3867 6.4 13.88ZM6.4 16C4.25333 14.1733 2.65 12.4767 1.59 10.91C0.53 9.34333 0 7.89333 0 6.56C0 4.56 0.643333 2.96667 1.93 1.78C3.21667 0.593333 4.70667 0 6.4 0C8.09333 0 9.58333 0.593333 10.87 1.78C12.1567 2.96667 12.8 4.56 12.8 6.56C12.8 7.89333 12.27 9.34333 11.21 10.91C10.15 12.4767 8.54667 14.1733 6.4 16Z",
    fill: "#406074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.b37a20c283d2160c58cde7f7c7421de1.svg";
export { ForwardRef as ReactComponent };